import clsx from "clsx";

import LoadingIcon from "../feedback/LoadingIcon";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
  size?: "regular" | "large" | "xs";
  variant?: "primary" | "secondary" | "danger";
}

const Button: React.FC<Props> = ({
  disabled,
  isLoading,
  children,
  size = "regular",
  variant = "primary",
  ...props
}) => (
  <button
    {...props}
    disabled={disabled === true || isLoading === true}
    className={clsx(
      "rounded-xl px-2.5 min-h-11 focus-visible:outline-2 focus-visible:outline-offset-2 w-full cursor-pointer",
      size === "xs"
        ? "text-xs py-1"
        : size === "regular"
          ? "text-sm py-2"
          : "text-lg font-semibold py-2",
      variant === "primary" || variant === "danger"
        ? "text-white"
        : "text-primary border border-border",
      variant === "primary"
        ? (disabled === true || isLoading === true)
          ? "bg-accent opacity-50 shadow-none"
          : "bg-accent shadow-glow hover:brightness-110 hover:shadow-glow-strong focus-visible:outline-accent"
        : variant === "danger"
          ? (disabled === true || isLoading === true)
            ? "bg-red-300"
            : "bg-red-600 hover:bg-red-700 focus-visible:outline-red-600"
          : (disabled === true || isLoading === true)
            ? "bg-surface opacity-50"
            : "bg-surface hover:bg-surface focus-visible:outline-accent",
    )}
  >
    {isLoading ? <LoadingIcon className="w-5 h-5 mx-auto" /> : children}
  </button>
);

export default Button;
